import React, { useEffect } from "react";
import { useSelector } from "../../../../../chronusStore/helper";
import SideBarTabs from "./SideBarTabs";

const SideBarSections = () => {
  const sections = useSelector(state => state.leftNav.sections);
  const hasTabs = sections?.some(section => section.tabs?.length > 0);

  useEffect(()=> {
    if(hasTabs) Navigation.handleAccessibility();
  }, [sections])

  return (
    <div className="cjs_side_bar d-flex flex-column cui-flex-gap-24">
      {
        sections?.map((section, index) => {
          return <SideBarTabs
            key={ index }
            sectionId={ index }
            sectionTitle={ section.sectionTitle }
            tabs={ section.tabs }
          />
        })
      }
    </div>
  )
}

export default SideBarSections;
